import { LegalPage } from "@/components/LegalPage";

const SEO = {
    metaTitle: "Accessibility Statement | EasiLinked",
    metaDescription:
        "EasiLinked's commitment to an accessible website, the standard we follow (WCAG 2.2 Level AA), known limitations, and how to get help.",
    canonicalUrl: "https://easilinked.com/accessibility",
};

const sections = [
    {
        id: "commitment",
        heading: "Our commitment",
        body: (
            <p>
                We want everyone to be able to learn about EasiLinked and reach us, regardless of ability or the
                technology they use. Our goal is for easilinked.com to conform to the Web Content Accessibility
                Guidelines (WCAG) 2.2 at Level AA.
            </p>
        ),
    },
    {
        id: "measures",
        heading: "What we do",
        body: (
            <ul>
                <li>Use semantic page structure, with headings and landmarks that work with screen readers.</li>
                <li>Support keyboard navigation and visible focus indicators on interactive elements.</li>
                <li>Check text and background color contrast in both light and dark themes.</li>
                <li>Turn off smooth scrolling when your device is set to reduce motion.</li>
                <li>
                    Test every page type with automated WCAG 2.2 Level AA checks before changes go live. As of the date
                    above, those checks report no violations.
                </li>
            </ul>
        ),
    },
    {
        id: "limitations",
        heading: "Known limitations",
        body: (
            <p>
                {"The Domain Security Health Check on our homepage is provided by our partner EasyDMARC and loads in their own frame. We have labeled it for assistive technology, but we do not control its content. If it does not work for you, contact us and we will review your domain for you. Automated testing also cannot catch every issue, so we welcome your feedback."}
            </p>
        ),
    },
    {
        id: "feedback",
        heading: "Feedback and assistance",
        body: (
            <p>
                {"If you have trouble using any part of this site, or need information in a different format, email "}
                <a href="mailto:info@easilinked.com">info@easilinked.com</a>
                {" or call (818) 217-0528, Monday to Friday, 8:00 AM to 5:00 PM Pacific. Please tell us the page and what you were trying to do. We aim to respond within two business days."}
            </p>
        ),
    },
];

export default function AccessibilityPage() {
    return (
        <LegalPage
            seo={SEO}
            eyebrow="Accessibility"
            title="Accessibility Statement"
            updated="October 27, 2026"
            intro="EasiLinked is committed to making our website usable for as many people as possible."
            sections={sections}
        />
    );
}
